import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import Button, { BUTTON_WIDTH } from '@gc-npm/components.button';
import IconGlyph from '@gc-npm/components.icon-glyph';
import CustomLink from '@gc-npm/components.custom-link';
import TextInfo, {
  TEXT_COLOR,
  TEXT_FONT_WEIGHT,
  TEXT_SIZE,
  TEXT_ALIGN,
  TEXT_KIND,
  TEXT_DISPLAY,
} from '@gc-npm/components.text';
import sendGaEvent from '@gc-npm/utils.metrics.send-ga-event';
import { actions as modalActions } from '@gc-npm/reducers.modals-reducer';

import { SCREEN_TYPES } from '@/utils/constants';
import { COLORS } from '@gc-npm/utils.enums.colors';

const COMPONENT_NAME = 'PurchaseInProgressModal';

const PurchaseInProgressModal = ({
  screenType,
  title,
  description,
  buttonLabel,
  items,
}) => {
  const dispatch = useDispatch();

  const componentProduct = items && Array.isArray(items) && items.join('-');

  const taggingInfo = {
    componentName: COMPONENT_NAME,
    componentContent: title || '',
    componentProduct: componentProduct || '',
    componentVariation: '',
  };

  const onCloseModal = () => {
    dispatch(
      modalActions.addModal({
        id: '',
      }),
    );
  };

  useEffect(() => {
    sendGaEvent({
      ...taggingInfo,
      eventType: 'print-success',
    })
  }, []);

  return (
    <>
      <div className="PurchaseInProgressModal">
        <div className="PurchaseInProgressModal_close">
          <CustomLink
            taggingInfo={{ ...taggingInfo, componentContent: 'Cerrar' }}
            onClick={onCloseModal}
          >
            <IconGlyph
              id="Cerrar"
              height={14}
              width={14}
              color={TEXT_COLOR.MOVISTAR_BLUE}
            />
          </CustomLink>
        </div>
        <hr />
        {title && (
          <TextInfo
            kind={TEXT_KIND.PARAGRAPH}
            display={TEXT_DISPLAY.BLOCK}
            align={TEXT_ALIGN.LEFT}
            color={TEXT_COLOR.GREY6}
            size={TEXT_SIZE.T4}
            fontType={TEXT_FONT_WEIGHT.BOLD}
            text={title}
          />
        )}
        {
          items
          && Array.isArray(items)
          && items.length > 0
          && (
            <ul className="PurchaseInProgressModal_items">
              {items.map((item) => {
                return (
                  <li className="PurchaseInProgressModal_items-item">{item}</li>
                )
              })}
            </ul>
          )
        }
        {description && (
          <TextInfo
            kind={TEXT_KIND.PARAGRAPH}
            display={TEXT_DISPLAY.BLOCK}
            align={TEXT_ALIGN.LEFT}
            color={TEXT_COLOR.GREY6}
            size={TEXT_SIZE.BODY1}
            fontType={TEXT_FONT_WEIGHT.REGULAR}
            text={description}
          />
        )}
        {buttonLabel && (
          <Button
            label={buttonLabel}
            onClick={onCloseModal}
            taggingInfo={{
              ...taggingInfo,
              componentContent: buttonLabel,
            }}
            width={screenType === SCREEN_TYPES.MOBILE ? BUTTON_WIDTH.FULL : BUTTON_WIDTH.MEDIUM}
            forceExternal
          />
        )}
      </div>
      <style jsx>
        {`
            .PurchaseInProgressModal {
                background-color: #fff;
                padding: 2rem;
                border-radius: 1rem;
                display: flex;
                flex-direction: column;
                gap: 1rem;
                &_close {
                  display: flex;
                  justify-content: flex-end;
                }
                hr {
                  width: 100%;
                  color: ${COLORS.grey300};
                }
            }
            @media (max-width: 768px) {
                .PurchaseInProgressModal {
                  padding: 1rem;
                  width: 100vw;
                  border-radius: 1rem 1rem 0rem 0rem;
                  max-height: 80dvh;
                }
            }
        `}
      </style>
    </>
  );
};

export default PurchaseInProgressModal;
